jQuery(document).ready(function($) {
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    var product_temp = $('#data-single-product');
    if (product_temp.length > 0) {
        var product = product_temp.html();
        product = JSON.parse(product);
        var image_src = product.featured_image;
        var images = product.images;
        if (image_src == null) {
            if (images != null) {
                for (var i in images) {
                    if (typeof images[i].src != 'undefined') {
                        image_src = images[i].src;
                    }
                }
            }
        }
        var filter = {
            id: product.id,
            title: product.title,
            handle: product.handle,
            image: image_src,
            price: product.price
        }
        var products = getCookie('product_recent');
        if (products.length !== 0) products = JSON.parse(products);
        if (products.length == 0) {
            products = [];
        }
        for (var i = products.length - 1; i >= 0; i--) {
            if (products[i].id == product.id) {
                return;
            }
        }
        products.push(filter);
        setCookie('product_recent', JSON.stringify(products), 30 * 86400);
    }
    var history = $('.history-view');

    var products = getCookie('product_recent');
    if(products.length == 0 || JSON.parse(products).length == 0){
        history.hide();
    }
    
    if (history.length > 0) {
        var content = history.find('.history-content');
        content.find('.history-owl').remove();
        var items = jQuery('<div/>', {
            'class': 'history-owl owl-carousel'
        }).prependTo(content);
        var products = getCookie('product_recent');
        if (products.length == 0) {
            history.hide();
            return false;
        } else {
            history.show();
        }
        products = JSON.parse(products);
        for (var i = products.length - 1; i >= 0; i--) {
            var product = products[i];
            var temp = '<div class="item">' + '<a href="#" class="remove-history" data-id="' + product.id + '"><span>&#x2715;</span></a>' + '<div class="history-image">' + '<a href="/products/' + product.handle + '"><img src="' + product.image + '" alt="' + product.title + '"></a></div></div>';
            items.append(temp);
        }
        items.owlCarousel({
            responsiveClass: true,
            margin: 20,
            autoplay: true,
            nav: true,
            dots: true,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 5
                }
            }
        });
        $('.next-item').click(function() {
            items.trigger('next.owl.carousel');
        });
        $('.prev-item').click(function() {
            items.trigger('prev.owl.carousel', [300]);
        });
    }
    $('.remove-all-history').on('click', function(e) {
        e.preventDefault();
        setCookie('product_recent', "", 30 * 86400);
        history.remove();
    })
    $(document).on('click', '.remove-history', function(e) {
        e.preventDefault();
        var products = getCookie('product_recent');
        if (products.length == 0) {
            history.hide();
            return false;
        } else {
            history.show();
        }
        products = JSON.parse(products);
        var product_id = $(this).attr('data-id');
        for (var i = 0; i < products.length; i++) {
            if (products[i].id == product_id) {
                products.splice(i, 1);
                break;
            }
        }
        setCookie('product_recent', JSON.stringify(products), 30 * 86400);
        if (products.length > 0) {
            $(this).parents('.owl-item').remove();
        } else {
            history.remove();
        }
    });
    var newsletter = $("#myModal");
    var isloged = getCookie('visited');
    setCookie('visited', true, 60);
    if (isloged == "") {
        newsletter.modal('show');
    }
});